/**
 * OIH Heritage logo mark — SVG "tree of life" over a mosaic band,
 * inspired by the Office of Ismaili Heritage Canada wordmark.
 * Restrained, monochromatic version for nav; multi-tone for hero.
 */
export function OihMark({ size = 40, tone = "navy" }) {
  // tone: "navy" (dark bg) | "light" (light bg)
  const trunk = tone === "navy" ? "#d4b587" : "#1b3966";
  const leavesBlue = tone === "navy" ? "#5f8ac6" : "#1b3966";
  const leavesGreen = tone === "navy" ? "#a8b78d" : "#587847";
  const band = tone === "navy" ? "#b8874a" : "#276a6d";

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"
         role="img" aria-label="Office of Ismaili Heritage">
      {/* leaves — clustered dots forming a canopy */}
      <g fill={leavesBlue} opacity="0.85">
        <circle cx="24" cy="16" r="2" />
        <circle cx="32" cy="12" r="2.2" />
        <circle cx="40" cy="16" r="2" />
        <circle cx="20" cy="22" r="1.8" />
        <circle cx="44" cy="22" r="1.8" />
        <circle cx="28" cy="20" r="1.6" />
      </g>
      <g fill={leavesGreen} opacity="0.9">
        <circle cx="36" cy="20" r="1.6" />
        <circle cx="22" cy="18" r="1.4" />
        <circle cx="42" cy="18" r="1.4" />
        <circle cx="30" cy="16" r="1.4" />
        <circle cx="38" cy="14" r="1.4" />
      </g>
      {/* trunk */}
      <path d="M32 22 L32 50" stroke={trunk} strokeWidth="2.2" strokeLinecap="round" />
      {/* branches */}
      <path d="M32 30 Q26 30 22 34" stroke={trunk} strokeWidth="1.4" fill="none" strokeLinecap="round" />
      <path d="M32 30 Q38 30 42 34" stroke={trunk} strokeWidth="1.4" fill="none" strokeLinecap="round" />
      <path d="M32 38 Q26 40 24 44" stroke={trunk} strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <path d="M32 38 Q38 40 40 44" stroke={trunk} strokeWidth="1.2" fill="none" strokeLinecap="round" />
      {/* mosaic band */}
      <rect x="14" y="48" width="36" height="4" rx="1" fill={band} opacity="0.85" />
      {/* roots */}
      <path d="M32 52 Q28 56 24 58" stroke={trunk} strokeWidth="1" fill="none" strokeLinecap="round" opacity="0.5" />
      <path d="M32 52 Q36 56 40 58" stroke={trunk} strokeWidth="1" fill="none" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}
